import styled from 'styled-components';
import { Text } from '@cko/primitives';
export const TruncateWord = styled(Text) `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: inherit;
`;
